function compareNumers(a: number, b: number): number {
  if (a < b) return -1;
  if (a > b) return 1;
  return 0;
}

function naturalCompare(a: string, b: string): number {
  const regex = /(\d+|\D+)/g; // splitting string into text and numbers
  const aParts = a.match(regex) || [];
  const bParts = b.match(regex) || [];

  for (let i = 0; i < Math.max(aParts.length, bParts.length); i += 1) {
    const aPart = aParts[i];
    const bPart = bParts[i];

    if (aPart === undefined || bPart === undefined) {
      return aParts.length - bParts.length;
    }

    const aIsNum = /^\d+$/.test(aPart);
    const bIsNum = /^\d+$/.test(bPart);

    if (aIsNum && bIsNum) {
      const aNum = parseInt(aPart, 10);
      const bNum = parseInt(bPart, 10);
      if (aNum !== bNum) return aNum - bNum;
    } else {
      const comp = aPart.localeCompare(bPart);
      if (comp !== 0) return comp;
    }
  }
  return 0;
}

function naturalSort<T extends string | number>(a: T, b: T, order: 1 | -1 = 1): number {
  if (typeof a === 'number' && typeof b === 'number') {
    return compareNumers(a, b) * order;
  }
  if (typeof a === 'string' && typeof b === 'string') {
    return naturalCompare(a, b) * order;
  }
  return 0;
}

function sort<T extends string | number>(a: T, b: T, order: 1 | -1 = 1): number {
  if (a < b) return -1 * order;
  if (a > b) return 1 * order;
  return 0;
}

export {
  sort,
  naturalSort
};
